import React, {Component} from 'react';
import {observer} from "mobx-react";

class Interactive extends Component {
  componentDidMount() {
    this._ref.addEventListener("click",(e)=>{
      // e.target.class
      if(e.target.classList.contains("mas-spoiler-title")) {
        e.target.parentNode.classList.toggle("mas-spoiler-opened");
      }
      console.log('target',{t:e.target});
    });
  }
  render() {
    return (
      <div ref={(ref)=>{ this._ref=ref; }}>
        {this.props.children}
      </div>
    )
  }
}

export default observer(Interactive);